// A wrapper for <Route> that redirects to the login

import React, { useState } from "react";
import { Redirect, Route, useParams } from "react-router-dom";
import { PATH } from "../../config";
import { useAuth } from "./ProvideAuth";
import Sidebar from "../../components/Sidebar";
import SidebarSticky from "../../assets/genericComponents";
import NavBar from "../../components/Navbar";
import { getInitials } from "../../assets";
import AppLayout from "../../assets/genericComponents/AppLayout";
import { useSelector } from "react-redux";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { MdCreateNewFolder } from "react-icons/md";
import { FcPlanner } from "react-icons/fc";
import TimeField from "react-simple-timefield";
import { IoIosArrowBack } from "react-icons/io";
import { success, USER_REQUEST } from "../../redux/actions/utilities";
import { useDispatch } from "react-redux";
import { IoClose } from "react-icons/io5";
import { FaChevronLeft } from "react-icons/fa";

// screen if you're not yet authenticated.
function PrivateRoute({ children, ...rest }) {
  const [show, setShow] = useState(true);
  const handleClose = () => {
    setShow(false);
    localStorage.setItem("isHidden", true);
  };
  let dispatch = useDispatch();
  const handleShow = () => setShow(true);
  const { landingModal } = useSelector((state) => state.user);
  function skipModal() {
    // console.log("test", landingModal)
    dispatch(success(USER_REQUEST.SET_LANDING_MODAL_STATE, false));
  }
  const [createProject, setCreateProject] = useState(true);
  const [planDay, setplanDay] = useState(false);

  const { type } = useParams();
  let auth = useAuth();

  function arrowDefault() {
    setCreateProject(true);
    setplanDay(false);
  }

  // console.log("landingModal", landingModal)
  const [modalsState, setmodalsState] = useState("sm");
  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth.user && auth.user.token ? (
          <>
            {(rest.path === PATH.FINANCE_DASHBOARD ||
              rest.path === PATH.TEAMSCHEDULER ||
              rest.path === PATH.DASHBOARD.replace(":type", type) ||
              rest.path === PATH.WORKLOAD ||
              rest.path === PATH.PROJECTS ||
              rest.path === PATH.KANBAN) && (
              <>
                <AppLayout>{children} </AppLayout>

                {/* <Sidebar />
                      {children} */}
              </>
            )}
            {rest.path !== PATH.FINANCE_DASHBOARD &&
              rest.path !== PATH.TEAMSCHEDULER &&
              rest.path !== PATH.DASHBOARD.replace(":type", type) &&
              rest.path !== PATH.WORKLOAD &&
              rest.path !== PATH.PROJECTS &&
              rest.path !== PATH.KANBAN && (
                // <>
                //   <NavBar showMenuBtn={false} getInitials={getInitials(`${auth.user.firstName} ${auth.user.lastName}`)} />
                //   <div className="container-fluid no-padding">
                //     <div className="row no-margin-right">
                //       <div className="col-4 col-md-2 no-padding-right">
                //         <SidebarSticky />
                //       </div>
                //       {children}
                //     </div>
                //   </div>
                // </>
                <>
                  <AppLayout>{children}</AppLayout>
                  <Modal
                    className="p-0"
                    aria-labelledby="contained-modal-title-vcenter"
                    id="user-welcome-card"
                    centered
                    // show={landingModal}
                    size={"md"}
                    onHide={handleClose}
                    animation={false}
                  >
                    {/* <Modal.Header className="border-0 pb-0" onClick={() => skipModal()}>
                                        </Modal.Header> */}
                    <Modal.Body className="py-3 px-2">
                      {createProject ? (
                        <>
                          {planDay ? null : (
                            <>
                              <Row>
                                <Col lg="12">
                                  <p
                                    className="text-right pr-2 cursor-pointer "
                                    onClick={() => skipModal()}
                                  >
                                    <u>
                                      <IoClose className="" />
                                    </u>
                                  </p>
                                </Col>
                              </Row>
                              <Row className="pt-3">
                                <Col>
                                  <div className="mb-3">
                                    <h4 className="text-center Welcome-txt mb-2">
                                      Welcome
                                    </h4>
                                    <p className="text-center Have-nice-text">
                                      Have a nice day!
                                    </p>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="mx-3">
                                <Col lg="12" className="px-0 mb-3">
                                  <Button
                                    className="button-sizes w-100 py-2 Home-buttons cursor-pointer"
                                    onClick={() => {
                                      setCreateProject(false);
                                      setmodalsState("lg");
                                    }}
                                  >
                                    Create New Project
                                  </Button>
                                </Col>
                                <Col lg="12" className="px-0 mb-4">
                                  <Button
                                    className="button-sizes plan-day py-2 w-100  w-100"
                                    onClick={() => {
                                      setplanDay(true);
                                      setmodalsState("lg");
                                    }}
                                  >
                                    Plan Your Day
                                  </Button>
                                </Col>
                              </Row>
                            </>
                          )}
                        </>
                      ) : (
                        <div className="px-3 b7">
                          <div className="d-flex border-bottom pb-2 justify-content-between mb-2">
                            <div className="d-flex align-items-center justify-content-between w-100">
                              <div className=" d-flex align-items-center">
                                <FaChevronLeft
                                  className="f-13 cursor-pointer"
                                  onClick={arrowDefault}
                                />
                                <h5 className="generic-heading-level-3 py-1 pl-2">
                                  Create Project
                                </h5>
                              </div>
                              <p
                                className="text-right cursor-pointer "
                                onClick={() => skipModal()}
                              >
                                <u>
                                  <IoClose className="" />
                                </u>
                              </p>
                            </div>
                            <p></p>
                          </div>
                          <Row className="mb-3 mt-3">
                            <Col lg="12">
                              <Form.Group className="mb-2">
                                <label className="salary-labels">
                                  {"Project Name"}
                                </label>
                                <Form.Control
                                  className="mb-2"
                                  type="Text"
                                  placeholder="Project Name"
                                />
                              </Form.Group>
                            </Col>
                            <Col lg="6">
                              <Form.Group>
                                <label className="salary-labels">
                                  {"Category"}
                                </label>
                                <Form.Control
                                  className="mb-2"
                                  as="select"
                                  name="bdProjectCategoryId"
                                >
                                  <option value="0">Select Category</option>
                                  <option>HealthCare</option>
                                </Form.Control>
                              </Form.Group>
                            </Col>
                            <Col lg="6">
                              <Form.Group>
                                <label className="salary-labels">
                                  {"Status"}
                                </label>
                                <Form.Control
                                  as="select"
                                  name="bdProjectCategoryId"
                                >
                                  <option value="0">Select Status</option>
                                  <option>New</option>
                                </Form.Control>
                              </Form.Group>
                            </Col>
                            <Col lg="6">
                              <Form.Group>
                                <label className="salary-labels">
                                  {"Project Lead"}
                                </label>
                                <Form.Control
                                  as="select"
                                  name="bdProjectCategoryId"
                                >
                                  <option value="0">Select Lead</option>
                                  <option>Ayaz</option>
                                </Form.Control>
                              </Form.Group>
                            </Col>
                            <Col lg="6">
                              <Form.Group>
                                <Form.Label className="salary-labels">
                                  Project Team
                                </Form.Label>
                                <Form.Control
                                  as="select"
                                  name="bdProjectCategoryId"
                                >
                                  <option value="0">Select Team</option>
                                  <option>Management</option>
                                </Form.Control>
                              </Form.Group>
                            </Col>
                          </Row>

                          <Row>
                            <Col lg="12">
                              <Form.Group className="mb-2">
                                <label className="salary-labels">
                                  {"Project Price"}
                                </label>
                                <Form.Control
                                  className="mb-2"
                                  type="Text"
                                  placeholder="Type Price here"
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="12">
                              <Button
                                type="submit"
                                className="mt-4 py-2 mb-2 w-100 button-sizes Home-buttons"
                              >
                                Save
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      )}
                      {planDay ? (
                        <div className="px-3">
                          <div className="d-flex border-bottom pb-2 justify-content-between mb-3">
                            <div className="d-flex align-items-center justify-content-between w-100">
                              <div className="d-flex">
                                <FaChevronLeft
                                  className="f-13 cursor-pointer"
                                  onClick={arrowDefault}
                                />
                                <h5
                                  className="
                                                            generic-heading-level-3
                                                           pb-2 pl-2"
                                >
                                  Plan a Day
                                </h5>
                              </div>

                              <p
                                className="text-right cursor-pointer "
                                onClick={() => skipModal()}
                              >
                                <u>
                                  <IoClose className="" />
                                </u>
                              </p>
                            </div>
                            <p></p>
                          </div>

                          <Row>
                            <Col lg="12">
                              <Form.Group>
                                <label className="salary-labels">
                                  {"Employee"}
                                </label>
                                <Form.Control
                                  as="select"
                                  name="bdProjectCategoryId"
                                  className="mb-2"
                                >
                                  <option value="0">Select Employee</option>
                                  <option>Fahad</option>
                                </Form.Control>
                              </Form.Group>
                            </Col>
                            <Col lg="6">
                              <Form.Group>
                                <label className="salary-labels">
                                  {"Project"}
                                </label>
                                <Form.Control
                                  as="select"
                                  name="bdProjectCategoryId"
                                  className="mb-2"
                                >
                                  <option value="0">Select Project</option>
                                  <option>New</option>
                                </Form.Control>
                              </Form.Group>
                            </Col>
                            <Col lg="6">
                              <Form.Group className="mb-3">
                                <label className="salary-labels">
                                  {"Task Name"}
                                </label>
                                <Form.Control
                                  type="Text"
                                  placeholder="Task Name"
                                />
                              </Form.Group>
                            </Col>

                            <Col lg="12">
                              <label className="salary-labels">
                                {"Task Description"}
                              </label>
                              <Form.Control
                                className="mb-2"
                                as="textarea"
                                placeholder="Leave a comment here"
                                style={{ height: "100px" }}
                              />
                            </Col>

                            <Col lg="6">
                              <Form.Group>
                                <label className="salary-labels">
                                  {"Task Category"}
                                </label>
                                <Form.Control
                                  className="mb-2"
                                  as="select"
                                  name="bdProjectCategoryId"
                                >
                                  <option value="0">Select Category</option>
                                  <option>New</option>
                                </Form.Control>
                              </Form.Group>
                            </Col>

                            <Col lg="6">
                              <Form.Group>
                                <label className="salary-labels">
                                  {"Priority"}
                                </label>
                                <Form.Control
                                  as="select"
                                  name="bdProjectCategoryId"
                                >
                                  <option value="0">Select Priority</option>
                                  <option>New</option>
                                </Form.Control>
                              </Form.Group>
                            </Col>
                            <Col lg="6">
                              <Form.Group className="mb-3">
                                <label className="salary-labels">
                                  {"Estimated Time"}
                                </label>
                                <TimeField
                                  placeholder={"00:00:00"}
                                  input={
                                    <input
                                      type="text"
                                      value={""}
                                      className="form-control mb-2"
                                    />
                                  }
                                  colon=":"
                                  showSeconds
                                />
                              </Form.Group>
                            </Col>
                            <Col lg="6">
                              <Form.Group className="mb-3">
                                <label className="salary-labels">
                                  {"Due Date"}
                                </label>
                                <input type="date" className="form-control" />
                              </Form.Group>
                            </Col>
                            <Col lg="12">
                              <Form.Group>
                                <label className="salary-labels">
                                  {"Select Repeat Todo"}
                                </label>
                                <Form.Control className="mb-2" as="select">
                                  <option value="0">Select Type</option>
                                  <option>Daily</option>
                                  <option>Weekly</option>
                                  <option>Monthly</option>
                                </Form.Control>
                              </Form.Group>
                            </Col>
                          </Row>

                          <Row>
                            <Col className="d-flex justify-content-end">
                              <Button
                                type="submit"
                                className="mt-2 mb-2 py-2 w-100 button-sizes Home-buttons"
                              >
                                Save
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      ) : null}
                    </Modal.Body>
                  </Modal>
                  {/* <Sidebar />
                  {children} */}
                </>
              )}
          </>
        ) : (
          <Redirect
            to={{
              pathname: PATH.HOMEPAGE,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
export default PrivateRoute;
